export { ReactTemplate } from './src/template';
